import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import { cpfOuStringComum, flatPhone, timeout } from '@/utils/common'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  secretaria: boolean,
}

enum PessoaGeneroEnum {
  NaoInformado = 'NaoInformado',
  Masculino = 'Masculino',
  Feminino = 'Feminino',
}

export enum TipoUsuarioAgendamento {
  SecretariaDoAmbulatorio = 'SecretariaDoAmbulatorio',
  SecretariaDoAgendamento = 'SecretariaDoAgendamento',
  SecretariaDoMedico = 'SecretariaDoMedico',
}

interface Medico {
  medicoId: string,
  medicoNome: string,
}

interface LocalAtendimento {
  id?: string,
  hospitalId?: string,
  localAtendimentoId: string,
  localAtendimentoNome: string,
  ambulatorio: boolean,
  listaDeMedicos?: Medico[],
  medicos: Medico[],
  naoEditarInformacoesAdicionais: boolean,
}

export interface HospitalSecretaria {
  hospitalId: string,
  hospitalNome: string,
  locaisAtendimento: LocalAtendimento[],
  locais?: [],
}

interface Secretaria {
  id: string,
  nome: string,
  documento: string,
  email: string,
  telefone: string,
  tipoUsuarioAgendamento: TipoUsuarioAgendamento,
  dataNascimento: string,
  sexo: PessoaGeneroEnum,
  hospitais: HospitalSecretaria[],
}

interface ResumoSecretaria {
  userId: string,
  email: string,
  documento: string,
  nome: string,
  tipoUsuarioAgendamento: TipoUsuarioAgendamento,
}
@Module({ namespaced: true, name: 'SuporteSecretariasStore' })
export default class SuporteSecretariasStore extends VuexModule {
  public searchSecretaria: string = ''
  public mode: Mode = 'CREATE'
  public modal: SuporteModal = {
    secretaria: false,
  }

  @Mutation
  setSearchSecretaria(val: string) {
    this.searchSecretaria = val
  }

  @Mutation
  clearSearchSecretaria() {
    this.searchSecretaria = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setMode(mode: Mode) {
    this.mode = mode
  }

  public hospitais: HospitalSecretaria[] = []

  @Mutation
  setHospitais(value: HospitalSecretaria[]) {
    this.hospitais = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Action
  async getAllHospitalSuporteConfiguracao() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllHospitalSuporteConfiguracao()
      if (request.success) {
        this.context.commit('setHospitais', (request.data as HospitalSecretaria[]).map((hospital: any) => ({
          hospitalId: hospital.hospitalId,
          hospitalNome: hospital.nome,
          locaisAtendimento: [],
          locais: [],
        })) || [])
      }
      return request
    } catch (error) {
      this.context.commit('setHospitais', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  removeHospital(value: string) {
    const index = this.secretaria.hospitais.findIndex((item: HospitalSecretaria) => item.hospitalId === value)
    if (index >= 0) this.secretaria.hospitais.splice(index, 1)
  }

  @Mutation
  removeLocalAtendimento(value: any) {
    const indexHospital = this.secretaria.hospitais.findIndex((item: HospitalSecretaria) => item.hospitalId === value.hospitalId)
    const indexLocalAtendimento = this.secretaria.hospitais[indexHospital].locaisAtendimento.findIndex(item => item.id === value.id)
    if (indexLocalAtendimento >= 0) this.secretaria.hospitais[indexHospital].locaisAtendimento.splice(indexLocalAtendimento, 1)
  }

  @Mutation
  removeMedico(value: any) {
    const indexHospital = this.secretaria.hospitais.findIndex((item: HospitalSecretaria) => item.hospitalId === value.hospitalId)
    const indexLocalAtendimento = this.secretaria.hospitais[indexHospital].locaisAtendimento.findIndex(item => item.id === value.localAtendimentoId)
    const indexMedico = this.secretaria.hospitais[indexHospital].locaisAtendimento[indexLocalAtendimento].medicos.findIndex(item => item.medicoId === value.medicoId)
    if (indexMedico >= 0) this.secretaria.hospitais[indexHospital].locaisAtendimento[indexLocalAtendimento].medicos.splice(indexMedico, 1)
  }

  @Mutation
  setLocais(value: any) {
    value.hospitaisIds.forEach((hospitalId: string) => {
      const indexHospital = this.secretaria.hospitais.findIndex((item: HospitalSecretaria) => item.hospitalId === hospitalId)
      this.secretaria.hospitais[indexHospital].locais = value.locais
        .filter((local: any) => local.hospitalId === hospitalId)
        .map((local: any) => ({ ...local, listaDeMedicos: local.medicos, medicos: [] }))
    })
  }

  @Action
  async getAllLocaisAtendimentoByHospitalId(hospitais: string[]) {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos(hospitais)
      if (request.success) this.context.commit('setLocais', { locais: request.data.locaisAtendimento as LocalAtendimento[] || [], hospitaisIds: hospitais })
      return request
    } catch (error) {
      this.context.commit('setLocais', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  setLocaisBySecretaria(locaisAtendimento: LocalAtendimento[]) {
    const mappedLocais = locaisAtendimento.reduce((acc, item) => {
      if (!acc[item.hospitalId!]) acc[item.hospitalId!] = []
      const { medicos, ...rest } = item
      acc[item.hospitalId!].push({ ...rest, listaDeMedicos: medicos })
      return acc
    }, {})

    Object.entries(mappedLocais).forEach(([key, value]) => {
      const hospital = this.secretaria.hospitais.find((item: HospitalSecretaria) => item.hospitalId === key)
      // @ts-ignore
      hospital.locais = value
      // @ts-ignore
      hospital.locais.forEach((local: any) => {
        // @ts-ignore
        const localAtendimento = hospital.locaisAtendimento.find(loc => loc.id === local.id)
        // @ts-ignore
        localAtendimento.listaDeMedicos = local.listaDeMedicos
        // @ts-ignore
        delete local.listaDeMedicos
      })
    })
  }

  @Action
  async getAllLocaisAtendimentoBySecretaria(hospitais: string[]) {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllLocaisDeAtendimentoEMedicos(hospitais)
      if (request.success) this.context.commit('setLocaisBySecretaria', request.data.locaisAtendimento as LocalAtendimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setLocaisBySecretaria', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Secretárias */
  private secretariasDefault: ResumoSecretaria[] = []
  public secretarias: ResumoSecretaria[] = [...this.secretariasDefault]
  private secretariaDefault: Secretaria = {
    id: '',
    nome: '',
    documento: '',
    email: '',
    telefone: '',
    tipoUsuarioAgendamento: TipoUsuarioAgendamento.SecretariaDoAgendamento,
    dataNascimento: '',
    sexo: PessoaGeneroEnum.Feminino,
    hospitais: [],
  }

  public secretaria: Secretaria = { ...this.secretariaDefault }

  private paginationSecretariaDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100],
  }

  public paginationSecretaria: DataTablePagination = { ...this.paginationSecretariaDefault }

  get paginationDefault() {
    return this.paginationSecretariaDefault
  }

  @Mutation
  setSecretariaField({ field, value }: { field: string, value: any }) {
    this.secretaria[field] = value
  }

  @Mutation
  setSecretarias(value: ResumoSecretaria[]) {
    this.secretarias = value
  }

  @Mutation
  clearSecretarias() {
    this.secretarias = [...this.secretariasDefault]
  }

  @Mutation
  setSecretaria(value: Secretaria) {
    this.secretaria = {
      ...value,
      dataNascimento: value.dataNascimento ? new Date(value.dataNascimento).toISOString().substring(0, 10) : '',
    }
  }

  @Mutation
  clearSecretaria() {
    this.secretaria = { ...this.secretariaDefault }
  }

  @Mutation
  setPaginationSecretaria(val: DataTablePagination) {
    this.paginationSecretaria = val
  }

  @Action
  async getSecretariaPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page,
        qtdPorPagina: pagination.rowsPerPage,
        searchText: cpfOuStringComum(this.searchSecretaria),
      }

      const request = await Apis.Agendamento.SuporteApi.getAllSecretarias(params)

      if (request.success) {
        this.context.commit('setSecretarias', request.data.secretarias as ResumoSecretaria[])
        this.context.commit('setPaginationSecretaria', {
          descending: false,
          page: pagination.page || this.paginationSecretariaDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationSecretariaDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationSecretariaDefault.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setSecretarias', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSecretariaById(id: string) {
    try {
      const request = await Apis.Agendamento.SuporteApi.getSecretariaById(id)
      if (request.success) {
        this.context.commit('setSecretaria', request.data as Secretaria)
        const hospitaisIds = this.secretaria.hospitais.map((h: HospitalSecretaria) => h.hospitalId)
        this.secretaria.hospitais = this.secretaria.hospitais.map((h: HospitalSecretaria) => ({
          ...h,
          hospitalNome: this.hospitais.find((item: any) => item.hospitalId === h.hospitalId)!.hospitalNome || '',
        }))
        await this.context.dispatch('getAllLocaisAtendimentoBySecretaria', hospitaisIds)
        await this.context.dispatch('getAllLocaisAtendimentoByHospitalId', hospitaisIds)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertSecretaria() {
    try {
      const params: any = { ...this.secretaria }
      params.telefone = params.telefone ? flatPhone(params.telefone) : ''

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
        // Limpeza de listas temporárias...
        if (key === 'hospitais') {
          params[key].forEach((hospital: any) => {
            delete hospital.locais
            if (hospital.locaisAtendimento && !!hospital.locaisAtendimento.length) {
              hospital.locaisAtendimento.forEach((local: any) => delete local.listaDeMedicos)
            }
          })
        }
      })

      const request = await Apis.Agendamento.SuporteApi.upsertSecretaria(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
